module.exports = "<h1 class=\"page-header\">My Login Activity</h1>\r\n\r\n<div class=\"table-responsive\">\r\n    <table class=\"table table-hover table-striped\">\r\n        <tr>\r\n            <th>Action</th>\r\n            <th>Date</th>\r\n        </tr>\r\n        <tr *ngFor=\"let item of logdata\" class=\"active\">\r\n            <td>{{ item.type }}</td>\r\n            <td>{{ item.date }}</td>\r\n        </tr>\r\n    </table>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/secure/useractivity/useractivity.html
// module id = ./src/app/secure/useractivity/useractivity.html
// module chunks = main